import React from "react";
import { Container } from "react-bootstrap";
import Slider from "../../Components/Slider/Slider";
import { EmptyState } from "../../Components/PageState/PageState";
import { useApp } from "../../context/AppContext";
const MyList = () => { const { myList } = useApp(); return <Container fluid className="content-page">{myList.length ? <Slider title="My List" movies={myList} /> : <EmptyState title="Your list is empty">Use the plus button on a title to save it here.</EmptyState>}</Container>; };
export default MyList;
